import axios from "axios";

export const fetchAppConfigApi = async (signal) => {
  // fetches the application configuration data from the server
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/appConfig`,
      { signal }
    );
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const updateAppConfigApi = async (
  id,
  updatedData,
  token,
  signal = null
) => {
  // updates the application configuration data on the server
  // id (String): id of the app config settings document
  // udpatedData (JSON): json with the updated config data
  //    - storeName (String)
  //    - email (String)
  //    - phone (String)
  //    - address {   street (String),   city (String),
  //                  province (String), postalCode (String)
  //                  topImage ({url (String), public_id (String)}),
  //                  topVideo ({url (String), public_id (String)}),
  //                  footerImage ({url (String), public_id (String)}) }
  // token (String): bearer token used for authentication
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    // configure header with bearer token for authorization
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/appConfig/${id}`,
      updatedData,
      config,
      { signal }
    );
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};
